import React, { useEffect, useState } from 'react';
import { Button, Col, FormGroup } from 'reactstrap';
import ReactFlagsSelect from 'react-flags-select';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import * as dataCentreActions from '../../actions/dataCentreActions';
import XMAuditTable from '../../components/XMAuditTable';

// Migrated from redux-form to react-hook-form. countryCode stays local state
// (ReactFlagsSelect was never a redux-form field).
const DataCentreForm = ({ initialValues, isEdit, handleCancel, toggle }) => {
  const dispatch = useDispatch();
  const one = useSelector((state) => state.dataCentre.one) || {};
  const [countryCode, setCountryCode] = useState(null);
  const { register, handleSubmit, reset } = useForm({ defaultValues: initialValues || {} });

  useEffect(() => {
    if (initialValues) reset(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues && initialValues.id]);

  const onSubmit = (dataCentre) => {
    if (countryCode) dataCentre.countryCode = countryCode;
    dispatch(dataCentreActions.save(dataCentre));
    toggle();
  };

  const onCancel = () => {
    handleCancel();
    toggle();
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
        <FormGroup row>
          <Col md="3">
            <label htmlFor="countryCode">Flag</label>
          </Col>
          <Col md="8" className="align-middle">
            <ReactFlagsSelect
              id="countryCode"
              name="countryCode"
              rfsKey="countryCode"
              selected={one.countryCode ?? countryCode}
              searchable
              className="menu-flags"
              selectButtonClassName="menu-flags-btn"
              onSelect={setCountryCode}
            />
          </Col>
        </FormGroup>
        {isEdit ? (
          <FormGroup row>
            <Col md="3">
              <label htmlFor="code">Code</label>
            </Col>
            <Col md="8">
              <input {...register('code')} type="text" className="form-control" disabled />
            </Col>
          </FormGroup>
        ) : null}
        <FormGroup row>
          <Col md="3">
            <label htmlFor="name">Name</label>
          </Col>
          <Col md="8">
            <input {...register('name')} type="text" className="form-control" />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md="3">
            <label htmlFor="region">Region</label>
          </Col>
          <Col md="8">
            <input {...register('region')} type="text" className="form-control" />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md="3">
            <label htmlFor="dbInstance">DB Instance</label>
          </Col>
          <Col md="8">
            <input {...register('dbInstance')} type="text" className="form-control" />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md="3">
            <label htmlFor="dbHost">DB Host</label>
          </Col>
          <Col md="8">
            <input {...register('dbHost')} type="text" className="form-control" />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md="3">
            <label htmlFor="dnsRecordSet">DNS Record Set</label>
          </Col>
          <Col md="8">
            <input {...register('dnsRecordSet')} type="text" className="form-control" />
          </Col>
        </FormGroup>
        <div className="float-end">
          <Button type="button" color="secondary" className="me-2" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" color="primary">
            Save
          </Button>
        </div>
      </form>
      <XMAuditTable show={isEdit} audit={one} />
    </div>
  );
};

export default DataCentreForm;
